<template>
  <div id="examineSales">
    <div class="header flex-between">
      <div class="header-text">
        <h1>GIADA Friends管理-查看-陪同购买清单</h1>
      </div>

      <div class="header-button">
        <el-button class="push-button" icon="iconfont icon-fanhui" plain @click="backHistory">返回</el-button>
      </div>
    </div>
    <div class="flex-between">
      <div class="header-center flex-between">
        <div class="tabs" style="width: 1208px; margin-top: 10px">
          <el-card shadow="never" style="height: 80vh">
            <div style="margin-bottom: 10px">
              <span style="color: #a19b5a; font-weight: 700">陪同购买销售单</span>
            </div>
            <!-- 表格 -->
            <div>
              <el-table
                size="small"
                class="table-style"
                border
                :row-class-name="tableRowClassName"
                :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
                :cell-style="{ 'text-align': 'center' }"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="560px"
                v-el-table-infinite-scroll="load"
                v-loading="loading"
                infinite-scroll-disabled="onLoading"
              >
                <el-table-column type="index" width="45"></el-table-column>
                <el-table-column prop="bindSheetNo" label="单据号"></el-table-column>
                <el-table-column prop="custName" label="顾客姓名"></el-table-column>
                <el-table-column prop="name" label="单据类型">
                  <template slot-scope="scope">
                    {{
                    scope.row.saleType == 0
                    ? "销售"
                    : scope.row.saleType == 1
                    ? "换货"
                    : scope.row.saleType == 2
                    ? "退货"
                    : scope.row.saleType == 3
                    ? "预购单提货"
                    : scope.row.saleType == 10
                    ? "预购"
                    : scope.row.saleType == 11
                    ? "预购撤单"
                    : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="saleDate" width="150" label="销售日期">
                  <template slot-scope="scope">{{ scope.row.saleDate | dateFormat }}</template>
                </el-table-column>
                <el-table-column prop="beforeDiscountAmount" label="折前总价"></el-table-column>
                <el-table-column prop="sheetAmount" label="折后总价"></el-table-column>
                <el-table-column prop="realAmount" label="实际交易金额"></el-table-column>
                <el-table-column prop="shopName" label="门店"></el-table-column>
                <el-table-column prop="saleEmpName" label="品牌顾问"></el-table-column>
              </el-table>

              <el-alert
                v-if="total<=tableData.length"
                title="没有更多数据了!"
                type="warning"
                center
                :closable="false"
              ></el-alert>
            </div>
          </el-card>
        </div>
        <!-- 右侧列表相关链接 -->
        <!-- 使用封装的组件 -->
        <div style="margin-top: 10px; margin-left: 30px">
          <Rightcards :GFCrmID="queryInfo.GFCrmID"></Rightcards>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getcustSalePage } from "@/api/friends";
export default {
  name: "centre",
  components: {},
  data() {
    return {
      activeName: "first",
      labelPosition: "top",

      tableData: [],
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      formInline: {
        user: "",
        region: ""
      },
      queryInfo: {
        GFCrmID: this.$route.query.custID,
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      size: 0,
      pageSize: 0,
      loading: false
    };
  },
  mounted() {},
  created() {
    this.loading = true;
    this.getTableData();
  },
  computed: {
    onLoading() {
      return this.loading || this.total < this.tableData.length;
    }
  },
  methods: {
    load() {
      setTimeout(() => {
        if (this.total > this.tableData.length) {
          this.queryInfo.pageNo += 1;
          this.getTableData();
        }
      }, 1000);
    },
    getTableData() {
      this.loading = true;
      getcustSalePage(this.queryInfo).then(res => {
        console.log(res);
        this.tableData = this.tableData.concat(res.data.list);
        this.total = res.data.total;
        this.size = res.data.size;
        this.pageSize = res.data.pageSize;
        this.loading = false;
      });
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 点击返回按钮  返回上一页面
    backHistory() {
      // this.$router.go(-1); //返回上一层
      this.$router.push({
        path: "/Examine",
        query: {
          custID: this.$route.query.custID
        }
      }); //返回GF管理查看
    }
  }
};
</script>
<style lang="scss" scoped>
#examineSales {
}
.header {
  .header-text {
    width: 350px;
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}

.push-button {
  background-color: #e9e7d3;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  height: 30px;
  border-radius: 0 !important;
}
::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
}
</style>
